import {
  IconButton,
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  DrawerHeader,
  DrawerBody,
  VStack,
  Link,
  HStack,
  Text,
  Badge,
  Button,
} from "@chakra-ui/react";
import { NavLink } from "react-router-dom";
import { MenuIcon, LayoutDashboard, Wallet, Users, Calendar, FileText, BarChart3, MessageCircle, Plus } from "../icons";
import { BrandLogo } from "../ui";

const ITEMS = [
  { to: "/dashboard", label: "Visão geral", icon: LayoutDashboard },
  { to: "/recebiveis", label: "Recebíveis", icon: Wallet },
  { to: "/vinculos", label: "Vínculos", icon: Users },
  { to: "/calendario", label: "Calendário", icon: Calendar },
  { to: "/relatorios", label: "Comprovação", icon: FileText },
  { to: "/kpis", label: "Inteligência", icon: BarChart3 },
];

const EM_BREVE = [{ label: "Assistente WhatsApp", icon: MessageCircle }];

export default function MobileDrawer({ isOpen, onOpen, onClose, onRegistrarPlantao }) {
  return (
    <>
      <IconButton
        aria-label="Abrir menu"
        icon={<MenuIcon size={20} />}
        variant="ghost"
        display={{ base: "inline-flex", lg: "none" }}
        onClick={onOpen}
      />
      <Drawer isOpen={isOpen} placement="left" onClose={onClose}>
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <BrandLogo h="22px" />
          </DrawerHeader>
          <DrawerBody>
            <VStack align="stretch" spacing={1} mb={4}>
              <Button leftIcon={<Plus size={16} />} onClick={() => { onClose(); onRegistrarPlantao?.(); }}>
                Registrar plantão
              </Button>
            </VStack>
            <VStack align="stretch" spacing={1}>
              {ITEMS.map((item) => (
                <Link
                  key={item.to}
                  as={NavLink}
                  to={item.to}
                  onClick={onClose}
                  display="flex"
                  alignItems="center"
                  gap={3}
                  px={3}
                  py={2}
                  borderRadius="lg"
                  fontSize="sm"
                  fontWeight="medium"
                  _hover={{ bg: "app-muted", textDecoration: "none" }}
                  sx={{ "&.active": { bg: "accent-subtle", color: "accent-text" } }}
                >
                  <item.icon size={18} />
                  {item.label}
                </Link>
              ))}
              {EM_BREVE.map((item) => (
                <HStack key={item.label} px={3} py={2} color="app-muted-fg" opacity={0.6}>
                  <item.icon size={18} />
                  <Text flex={1} fontSize="sm">
                    {item.label}
                  </Text>
                  <Badge variant="statusSubtle" colorScheme="gray" fontSize="10px">
                    Breve
                  </Badge>
                </HStack>
              ))}
            </VStack>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
